import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import LoadConnections from '../loaders/LoadConnections';
import GlobalChatRoom from '../screens/chat/GlobalChatRoom';
import ContactProfile from '../screens/GlobalContacts/ContactProfile';
import GlobalContacts from '../screens/GlobalContacts/GlobalContacts';
import SendEmailToContact from '../screens/GlobalContacts/SendEmailToContact';
import {innerGlobalChatRoutes} from './globalChatRoutes';

const contactRoutes = props => (
    <Switch>
        <Route path={`${props.match.path}/chats`} component={innerGlobalChatRoutes} />
        <Route path={`${props.match.path}/email`} exact component={SendEmailToContact} />
        <Route path={`${props.match.path}`} exact component={ContactProfile} />
        <Redirect to={`${props.match.path}`} />
    </Switch>
);

export default props => (
    <LoadConnections>
        <Switch>
            <Route path={`${props.match.path}/:userId`} component={contactRoutes} />
            <Route path={`${props.match.path}`} exact component={GlobalContacts} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    </LoadConnections>
);
